var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadHighway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-2{stroke-dasharray:6.19 14.85;}.cls-3{stroke-dasharray:5.17 12.41;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.15,122.9v-31A60.12,60.12,0,1,0,93,152h89.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.19,124.34V93.54a32,32,0,1,0-32,32h90"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.04,
    y1: 121.87,
    x2: 139.04,
    y2: 118.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139,103.85V92.32a46.26,46.26,0,1,0-46.26,46.26h78.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 178.91,
    y1: 138.58,
    x2: 182.08,
    y2: 138.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.15,
    y1: 192.42,
    x2: 153.15,
    y2: 154.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.19,
    y1: 192.42,
    x2: 125.19,
    y2: 154.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.04,
    y1: 192.42,
    x2: 139.04,
    y2: 189.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 139.04,
    y1: 176.85,
    x2: 139.04,
    y2: 165.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.04,
    y1: 159.27,
    x2: 139.04,
    y2: 156.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadHighway);
export default __webpack_public_path__ + "static/media/ROAD_HIGHWAY.a7ce23579aed7d3c23d6554742c1626f.svg";
export { ForwardRef as ReactComponent };